<template>
  <div>
    <el-table
      :border="true"
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column v-if="hasPermissionToAuditLogs" :label="fields.id.label"  :prop="fields.id.name" sortable="custom">
        <template slot-scope="scope">{{ presenter(scope.row, 'id') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.name.label"
        :prop="fields.name.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'name') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.lastname.label"
        :prop="fields.lastname.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'lastname') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.email.label"
        :prop="fields.email.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'email') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.zipcode.label"
        :prop="fields.zipcode.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'zipcode') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.state.label"
        :prop="fields.state.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'state') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column>

      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/newsletter/${scope.row.id}`">
              <el-button type="text">
                <app-i18n code="common.view"></app-i18n>
              </el-button>
            </router-link>

            <router-link :to="`/newsletter/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button type="text">
                <app-i18n code="common.edit"></app-i18n>
              </el-button>
            </router-link>

            <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              type="text"
              v-if="hasPermissionToDestroy"
            >
              <app-i18n code="common.destroy"></app-i18n>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { NewsletterModel } from '@modules/newsletter/newsletter-model';
import { mapGetters, mapActions } from 'vuex';
import { NewsletterPermissions } from '@modules/newsletter/newsletter-permissions';
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { i18n } from '@shared/i18n';

const { fields } = NewsletterModel;

export default {
  name: 'app-newsletter-list-table',

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'newsletter/list/rows',
      count: 'newsletter/list/count',
      loading: 'newsletter/list/loading',
      pagination: 'newsletter/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'newsletter/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new NewsletterPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new NewsletterPermissions(this.currentUser).destroy;
    },

    fields() {
      return fields;
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'newsletter/list/doChangeSort',
      doChangePaginationCurrentPage:
        'newsletter/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'newsletter/list/doChangePaginationPageSize',
      doMountTable: 'newsletter/list/doMountTable',
      doDestroy: 'newsletter/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return NewsletterModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
</style>
